export default __webpack_public_path__ + "static/media/or-7.5e28b7fd.jpg";